import { useState } from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/orders/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import {
  OrderCrudProvider,
  useOrderCrudContext,
} from "@/context/orderCrudContext"
import { useNavigate } from "react-router-dom"

export default function OrderList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Sales</h5>
      </div>

      <OrderCrudProvider>
        <OrderTable />
      </OrderCrudProvider>
    </>
  )
}

function OrderTable() {
  const { openOrderDialog, setOpenOrderDialog, setSelectedOrderRow } =
    useOrderCrudContext()

  const navigate = useNavigate()

  return (
    <>
      <CustomTable
        label="Sales"
        columns={columns}
        apiPath="order"
        onAdd={() => setOpenOrderDialog(true)}
        onView={(rowData) => {
          navigate(`/sales/${rowData.id}`)
        }}
        onEdit={(rowData) => {
          setSelectedOrderRow(rowData)
          setOpenOrderDialog(true)
        }}
        onExport={true}
        onImport={true}
      />

      {openOrderDialog ? <Modal /> : null}
    </>
  )
}
